import Axios from "axios";

export const SelectCatNome = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/CatNome?coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "CATNOME_SELECT", payload: response.data });
    });
  };
};
